import { SvgIcon, SvgIconProps } from '@mui/material';

export const ACTIVE_BLUE = '#6A9FE9'; //'#B3D4FC'//#'#1976D2'

export const INACTIVE_GREY = "lightgrey";


interface ColumnIconProps extends SvgIconProps {
  disabled?: boolean;
}

interface SharedYProps extends SvgIconProps {
  enabled?: boolean;
}

interface DeltaIconProps extends SvgIconProps {
  enabled?: boolean;
}

interface Log2IconProps extends SvgIconProps {
  enabled?: boolean;
}

interface BoxAndWhiskerIconProps extends SvgIconProps {
  enabled?: boolean;
}

export const AddColumnIcon: React.FC<ColumnIconProps> = ({ disabled, color='inherit',  ...props }) => {
  
  const fill = disabled ? "lightgrey": "#757575";

  return (
    <SvgIcon>
      {/* The Grid */}
      <rect x="3" y="3" width="4" height="4" fill={fill} />
      <rect x="8" y="3" width="4" height="4" fill={fill} />
      <rect x="13" y="3" width="4" height="4" fill={fill} />
      <rect x="3" y="8" width="4" height="4" fill={fill} />
      <rect x="8" y="8" width="4" height="4" fill={fill} />
      <rect x="13" y="8" width="4" height="4" fill={fill} />
      <rect x="13" y="13" width="4" height="4" fill={fill} />
      <rect x="3" y="13" width="4" height="4" fill={fill} />
      <rect x="8" y="13" width="4" height="4" fill={fill} />
      {/* Circle */}
      <circle cx="16" cy="16" r="5" fill="white" />
      {/* Plus */}
      <path d="M16 13.5v5m-2.5-2.5h5" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
    </SvgIcon>
  );
}

export const RemoveColumnIcon: React.FC<ColumnIconProps> = ({ disabled, color='inherit', ...props }) => {

  let fill= disabled ? "lightgrey" : "#757575";

  return (
  <SvgIcon>
    {/* The Grid */}
    
    <rect x="3" y="3" width="4" height="4" fill={fill} />
    <rect x="8" y="3" width="4" height="4" fill={fill} />
    <rect x="13" y="3" width="4" height="4" fill={fill} />
    <rect x="3" y="8" width="4" height="4" fill={fill} />
    <rect x="8" y="8" width="4" height="4" fill={fill} />
    <rect x="13" y="8" width="4" height="4" fill={fill} />
    <rect x="13" y="13" width="4" height="4" fill={fill} />
    <rect x="3" y="13" width="4" height="4" fill={fill} />
    <rect x="8" y="13" width="4" height="4" fill={fill} />
    {/* Circle */}
    <circle cx="16" cy="16" r="5" fill="white" />
    {/* Minus */}
    <path d="M14 15h5" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
  </SvgIcon>)
};

export const YAxisIcon: React.FC<SharedYProps> = ({ enabled, ...props }) => {
  
  const color = enabled ? ACTIVE_BLUE : INACTIVE_GREY;

  return (
    <SvgIcon {...props} sx={{ color }} viewBox="0 0 64 64">
      <path d="M32 2C15.432 2 2 15.432 2 32s13.432 30 30 30s30-13.432 30-30S48.568 2 32 2zm3.198 33.627v10.881h-6.063V35.627L19.096 17.492h7.146l6.023 12.637l5.769-12.637h6.87l-9.706 18.135z" />
    </SvgIcon>
  );
};

export const XAxisIcon: React.FC<SharedYProps> = ({ enabled, ...props }) => {
  
  const color = enabled ? ACTIVE_BLUE : INACTIVE_GREY;

  return (
    <SvgIcon {...props} sx={{ color }} viewBox="0 0 64 64">
      <path d="M 32 2 C 15.432 2 2 15.432 2 32 s 13.432 30 30 30 s 30 -13.432 30 -30 S 48.568 2 32 2 z m 13 45 L 38 47 L 32 36 L 26 47 L 19 47 L 28 32 L 19 17 L 26 17 l 6 11 L 38 17 h 7 l -9 15 z" />

    </SvgIcon>
  );
};

export const MoveCursorIcon: React.FC<ColumnIconProps> = ({ disabled, color = 'inherit', ...props }) => {
  const fill = disabled ? INACTIVE_GREY : color;

  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      {/* Center circle */}
      <circle cx="12" cy="12" r="3" fill={fill} />

      {/* Top arrow */}
      <path d="M12 1 L8 5 L10 5 L10 11 L14 11 L14 5 L16 5 Z" fill={fill} />

      {/* Right arrow */}
      <path d="M23 12 L18 7 L18 10 L12 10 L12 14 L18 14 L18 17 Z" fill={fill} />

      {/* Bottom arrow */}
      <path d="M12 23 L8 19 L10 19 L10 13 L14 13 L14 19 L16 19 Z" fill={fill} />

      {/* Left arrow */}
      <path d="M1 12 L7 7 L7 10 L13 10 L13 14 L7 14 L7 17 Z" fill={fill} />
    </SvgIcon>
  );
};

export const BoxAndWhiskerIcon: React.FC<BoxAndWhiskerIconProps> = ({ enabled, ...props }) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      sx={{ 
        fontSize: 20,
        color: enabled ? ACTIVE_BLUE : INACTIVE_GREY, 
        ...props.sx 
      }}
    >
    {/* Top "T" shape */}
    <line x1="6" y1="4" x2="18" y2="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <line x1="12" y1="4" x2="12" y2="8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    
    {/* Rectangle (box) */}
    <rect x="8" y="8" width="8" height="8" fill="none" stroke="currentColor" strokeWidth="2" />
    
    {/* Bottom inverted "T" shape */}
    <line x1="6" y1="20" x2="18" y2="20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <line x1="12" y1="16" x2="12" y2="20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </SvgIcon>
  );
};

export const DeltaIcon: React.FC<DeltaIconProps> = ({ enabled, ...props }) => {
  return (
    <SvgIcon 
      {...props}
      viewBox="0 0 24 24"
    >
      <path d="M12 2L2 20h20L12 2zm0 4.5L18.2 18H5.8L12 6.5z" fill={enabled ? ACTIVE_BLUE : INACTIVE_GREY}/>
    </SvgIcon>
  );
};

export const Log2Icon: React.FC<Log2IconProps> = ({ enabled, ...props }) => {
  return (
    <SvgIcon 
      {...props}
      viewBox="0 0 24 24"
    >
      <text
          x="0"
          y="17"
          fontFamily="Arial, sans-serif"
          fontSize="12"
          fontWeight="bold"
          fill={enabled ? ACTIVE_BLUE : INACTIVE_GREY}
      >
          LOG2
      </text>
  </SvgIcon>
  );
};


